//总站门户
export const portalRouters = [
  //每一个链接都是一个对象
  {
    path: "/",
    redirect: {
      name: "portal",
    },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("../views/PortalHome/Home.vue"),
    meta: {
      title: "专业群首页",
    },
    children: [
      {
        path: "portal",
        name: "portal",
        component: () =>
          import("../views/PortalHome/childrens/CustomizedHome.vue"),
      },
      {
        path: "projectGroups",
        name: "subProjectPortal",
        component: () =>
          import("../views/PortalHome/childrens/CustomizedProjectGroup.vue"),
      },
      {
        path: "material",
        name: "materialPortal",
        component: () =>
          import("../views/PortalHome/childrens/CustomizedMaterial.vue"),
      },
      {
        path: "course",
        name: "coursePortal",
        component: () =>
          import("../views/PortalHome/childrens/CustomizedCourse.vue"),
      },
      {
        path: "notice/:noticeId",
        name: "notice",
        component: () =>
          import("../views/PortalHome/childrens/CustomizedNotice.vue"),
      },
      {
        path: "/course/:courseOpenId",
        name: "portalCourse",
        props: true,
        component: () => import("../views/CourseDetail/index.vue"),
        meta: {
          title: "课程详情",
        },
      },
      //总站素材
      {
        path: "/material/:materialId",
        name: "portalMaterial",
        props: true,
        component: () => import("../views/MaterialDetail/materialPreview.vue"),
        meta: {
          title: "素材预览",
        },
      },
    ],
  },
];
